import { useStore } from 'vuex'

import { getToken } from '@/utils/useToken'
import { useAlert } from '@/modules/composition/useAlert'

export const useAuth = () => {
	const store = useStore()
	const { errorAlert } = useAlert()

	const sendLogin = async ({ login, password }) => {
		store.commit('setLoading', true, { root: true })

		try {
			await getToken(login, password)
		} catch (e) {
			if (e.response?.status === 401) {
				errorAlert('Токен недействителен. Перезагрузите страницу и повторите вход в систему')
			} else if (e.response?.data) {
				errorAlert(e.response.data?.error_description || e.response.data?.message || 'Ошибка')
			}
		} finally {
			store.commit('setLoading', false, { root: true })
		}
	}

	return {
		sendLogin
	}
}
